var React = require('react');

function ExpandArrowsAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M.05 168V56a23.94 23.94 0 0 1 24-24h112c21.4 0 32.1 25.9 17 41l-36.2 36.2 107.2 107.2L184.4 256 77.15 148.75 41.05 185c-15.05 15.05-41 4.35-41-17zm407 159.1L371 363.25 263.7 256l-39.65 39.65 107.2 107.2-36.2 36.2c-15.1 15.1-4.4 41 17 41h112a23.94 23.94 0 0 0 24-24v-112c0-21.4-25.9-32.05-41-17z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M370.9 148.8L116.8 402.9 153 439c15.1 15.1 4.4 41-17 41H24a23.94 23.94 0 0 1-24-24V344c0-21.4 25.9-32.1 41-17l36.2 36.2 254.1-254.1L295.1 73c-15.1-15.1-4.4-41 17-41h112a23.94 23.94 0 0 1 24 24v112c0 21.4-25.9 32.1-41 17z","className":"fa-primary","key":2})]);
}

ExpandArrowsAlt.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = ExpandArrowsAlt;

ExpandArrowsAlt.default = ExpandArrowsAlt;
